import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Box, Grid, Button } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import EditIcon from '@mui/icons-material/Edit';



export const PatchListComp = (props) => {


    return (
        <Box>
            <Box>
                <Grid container>
                    <Grid md={2}>
                        <Box paddingRight={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Process</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={props.mystate.ddlProcessId}
                                    label="Process"
                                    onChange={(e) => props.HandleInputs(e, 'ddlProcessId')}
                                >
                                    {
                                        props.processList != undefined && props.processList.length > 0 ?
                                            props.processList.map((item, i) =>
                                                <MenuItem value={item.process_name}>{item.process_name}</MenuItem>
                                            )
                                            :
                                            null
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>

                    {props.mystate.reportingAgents != undefined && (props.mystate.reportingAgents).length > 0 ?
                        <Grid md={2}>
                            <Box paddingRight={2}>
                              
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Agents</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={props.mystate.ddlAgentName}
                                        label="Agenst"
                                        onChange={(e) => props.HandleInputs(e, 'ddlAgentName')}
                                    >
                                        {/* {props.mystate.reportingAgents != undefined && (props.mystate.reportingAgents).length > 0 ? */}
                                        <MenuItem selected value={'All'}>{'All'}</MenuItem>
                                        {/* : ''} */}
                                        {
                                            props.mystate.userList != undefined && props.mystate.userList.length > 0 ?
                                                props.mystate.userList.map((item, i) =>
                                                    // item.role == 'Agent' ?
                                                    props.mystate.loginUserProfile.includes('Super-Admin') ?
                                                        <MenuItem value={item.name}>{item.name}</MenuItem>
                                                        :
                                                        (props.mystate.reportingAgents).includes(item.name) ?
                                                            <MenuItem value={item.name}>{item.name}</MenuItem>
                                                            :
                                                            ''
                                                )
                                                :
                                                null
                                        }
                                    </Select>
                                </FormControl>
                            </Box>

                        </Grid>
                        : ''}
                   
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtStartDate')} label="Start Date" value={dayjs(props.mystate.txtStartDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid md={3}>
                        <Box marginTop={-1}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker onChange={(e) => props.HandleInputs(e, 'txtEndDate')} label="End Date" value={dayjs(props.mystate.txtEndDate)} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </Box>
                    </Grid>

                    <Grid md={2}>
                        <Box textAlign={'end'}>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.CustomSearch()}><SearchIcon></SearchIcon></Button>
                            <Button style={{ margin: 10 }} variant="outlined" onClick={() => props.Reload()}><CachedIcon></CachedIcon></Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box style={{ marginTop: '20px' }}>
                {
                    props.mystate.getPatchApi == false && props.mystate.getProcessList == false ?
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 350 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                key={'SrNo'}
                                                align={'left'}
                                                style={{ minWidth: 70 }}
                                                className='table-head-cell'
                                            >
                                                {'SrNo'}
                                            </TableCell>
                                            <TableCell
                                                key={'Owner'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Owner'}
                                            </TableCell>
                                            <TableCell
                                                key={'Customer'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Customer'}
                                            </TableCell>
                                            <TableCell
                                                key={'Patch Date'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Patch Date'}
                                            </TableCell>
                                            <TableCell
                                                key={'Updated On'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Updated On'}
                                            </TableCell>
                                            <TableCell
                                                key={'Stage'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Stage'}
                                            </TableCell>
                                            <TableCell
                                                key={'Details'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {''}
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            console.log(props.mystate.patchData)
                                        }
                                        {props.mystate.patchData != undefined && props.mystate.patchData.length > 0 ?
                                            props.mystate.patchData.map((item, i) => (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={item._id}>
                                                    <TableCell key={props.mystate.totalRecords + i + 1} align={'left'}>
                                                        {((props.mystate.setNo - 1) * props.mystate.perSet) + i + 1}
                                                    </TableCell>
                                                    <TableCell key={item.owner_name + i} align={'left'}>
                                                        {item.owner_name != undefined && item.owner_name != '' ? item.owner_name : 'User'}
                                                    </TableCell>
                                                    <TableCell key={item.cust_name + i} align={'left'}>
                                                        <span>{item.cust_name} <br></br> {'(' + item.cust_mobile + ')'}</span>
                                                    </TableCell>
                                                    <TableCell key={item.added_on + i} align={'left'}>
                                                        {item.added_on != undefined && item.added_on != '' ? item.added_on : 'NA'}
                                                    </TableCell>
                                                    <TableCell align={'left'}>
                                                        {item.updated_on != undefined ? item.updated_on : 'NA'}
                                                    </TableCell>
                                                    <TableCell key={item.stage + i} align={'left'}>
                                                        {item.stage}
                                                    </TableCell>
                                                    <TableCell key={item.cust_added_on + i} align={'left'}>
                                                    <Button size="small" onClick={() => props.GetLeadDetails(item._id, item)}><EditIcon></EditIcon></Button>
                                                </TableCell>

                                                </TableRow>
                                            ))
                                            : 'No Record Found'
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[50, 100, 200, 300]}
                                component="div"
                                count={props.mystate.totalRecords}
                                rowsPerPage={props.mystate.perSet}
                                // page={props.mystate.setNo == 1 ? 1 + '-' + props.mystate.perSet : props.mystate.perSet * (props.mystate.setNo - 1) + '-' + props.mystate.perSet * (props.mystate.setNo) }
                                page={props.mystate.setNo - 1}
                                onPageChange={(e) => props.handleChangePage(e,props.mystate.setNo - 1)}
                                //onPageChange={handleChangePage}
                                onRowsPerPageChange={(e) => props.handleChangeRowsPerPage(e)}
                            />
                        </Paper>
                        :

                        <Box>
                            <Skeleton height={75} />
                            <Skeleton animation="wave" variant="rectangular" height={250} />
                            <Skeleton height={75} />
                        </Box>
                }

            </Box>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={props.mystate.showAlert} autoHideDuration={2000} onClose={() => { props.handleCloseAlert() }}>
            <Alert
                onClose={() => { props.handleCloseAlert() }}
                severity={'error'}
                variant="filled"
                sx={{ width: '100%' }}

            >
                {props.mystate.alertMsg}
            </Alert>
        </Snackbar>
        </Box>


    );
}